module.exports = __webpack_public_path__ + "static/diyanchi-2f40c84bfbed5462246f322f672930c5.svg";